export const getFormattedNominativeMonth = (date, nominativeMonths) => {
    const monthIndex = date.getMonth();
    const month = nominativeMonths[monthIndex] ?? '';
    return month;
};
